<template>
  <div style="">
    <div>{{ $t("dashboard.last_reports") }}</div>
    <el-table :data="data" class="border" height="300">
      <el-table-column
        prop="faultType"
        :label="$t('vibration_analyze_report.faultType')"
      >
        <template slot-scope="scope">
          <span>
            {{ $t(`faultNames.${scope.row.faultType}`) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="severity"
        :label="$t('vibration_analyze_report.severity')"
      >
        <template slot-scope="scope">
          <span>
            <em
              class="color-circle"
              v-bind:style="{
                'background-color': getColor(scope.row.report.severity),
              }"
            ></em>
          </span>
          {{ $t(`common.${scope.row.report.severity}`) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.show')">
        <template slot-scope="scope">
          <span style="font-size: 12px">
            <el-button
              style="margin-top: 10px; margin-right: 10px; float: left"
              size="mini"
              @click="show(scope.row.report)"
              >{{ $t("common.show") }}</el-button
            >
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      width="60%"
      class="fault-report-dialog"
      title=""
      :visible.sync="previewShowForm"
    >
      <el-row>
        <el-col :span="24">
          <FaultReportView
            :imageName="activeReport.image"
            :report="activeReport"
            :faultType="activeReport.faultType"
            :createdAt="activeReport.createdAt"
            :pointPath="activeReport.pointPath"
            :severity="activeReport.severity"
            :info="activeReport.info"
            :name="activeReport.name"
            v-on:download="download"
            :showDownload="true"/>
        </el-col>
      </el-row>
    </el-dialog>
    <el-row ref="fault-report" v-show="false">
        <el-col :span="24">
          <FaultReportView
            :imageName="activeReport.image"
            :report="activeReport"
            :faultType="activeReport.faultType"
            :createdAt="activeReport.createdAt"
            :pointPath="activeReport.pointPath"
            :severity="activeReport.severity"
            :info="activeReport.info"
            :name="activeReport.name"
            :showDownload="false"/>
        </el-col>
      </el-row>
  </div>
</template>

<script>
import axios from "axios";
import treeHelper from "../../util/treeHelper";
import dayjs from "dayjs";
import FaultReportView from "../FaultReportView.vue";
import preferences from "../../util/preferences";
import colorLib from "../../util/colorLib";
import downloadPdf from '../../service/downloadPdf'
import { mapState} from "vuex";
export default {
  name: "LastReports",
  components: {
    FaultReportView,  
  },
  data() {
    return {
      data: [],
      activeReport: "",
      previewShowForm: false,
      htmlToPdfOptions: { 


filename: `test.pdf`, 
image: { 
    type: 'jpeg',
    quality: 2
}, 

enableLinks: true, 
html2canvas: { 
    scale: 1, 
    useCORS: true 
}, 

jsPDF: { 
    unit: "px", 
    format: [1110, 715], 
    orientation: 'landscape' 
} 
},
    };
  },
  methods: {
    getPointPath(point) {
      return treeHelper.pointIdToPath(this.flatTree,this.activeReport.point);
    },
    getColor(order) {
      return colorLib.getAlarmColorByOrder(order);
    },
    toDisplayDate(timestamp) {
      return dayjs(timestamp).format(preferences().localization.dateFormat);
    },
    async loadData() {
      const customerId = JSON.parse(localStorage.getItem("user")).customerId;

      var urlString = `${process.env.VUE_APP_APIURL}/fault-reports/unanswered-evaluations-count`;
      let resp = await axios.get(urlString);
      if (resp.status == 200) {
        const data = resp.data.data.detectionReports.map((d) => {
          return {
            point: treeHelper.pointIdToPath(this.flatTree,d._id),
            faultType: d.detectionType,
            report: d,
          };
        });

        data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1);

        this.data = data;
      } else {
        console.log("Error loading data");
      }
    },
    show(row) {
      row.info = {
        _id: row.code,
        description: row.description,
        evaluation: {
          questions: row.questions.sort((a, b) => (a.order < b.order ? -1 : 1)),
          isAnswered: row.isAnswered,
        },
        suggestions: row.suggestions,
      };
      this.activeReport = row;
      this.previewShowForm = true;
    },
    download() {
      downloadPdf.downloadPdf(this.$refs["fault-report"].$el, 712,1150)
    },
  },
computed:{
  ...mapState("tree",["flatTree"])
},
  mounted() {
    this.loadData();
  },
};
</script>